module.exports = "../../app/cells/pages/home/youtube_banner_cell.rb";